/* Así funciona · Gabinete de Baño con 2 Puertas (2257131)
   Todo sale de la foto real del gabinete ABIERTO en un baño (galeria_1; piezas en
   tiendas/nayhogar/funciona/gabinete-de-bano-con-2-puertas/hacer.py). La clienta toca cada puerta y la puerta gira
   sobre su bisagra con la cámara real de la foto (camara.py: ajustada con 16 esquinas del mueble, error 2 px): cada
   cara de la puerta (frente con persianas y pomo, cara de atrás con sus bisagras, canto y borde) es la textura real
   rectificada y proyectada en 3D en cada cuadro, con su luz según hacia dónde mira. Abiertas del todo, quedan
   EXACTAMENTE como la foto real (se funde a la foto) y se ve el interior real. Lo de detrás de la puerta izquierda
   (cortina, piso) está rehecho con píxeles de la misma foto. Ficha: repisas abiertas y 2 puertas, 90 x 40 x 25 cm,
   repisas de 24, 16 y 40 cm de alto, blanco. */
NHF.escena('gabinete-de-bano-con-2-puertas', function (E) {
  const D = /*DATOS*/{"tex":{"frente":"fn-gabinete-de-bano-con-2-puertas-frente.webp","atras":"fn-gabinete-de-bano-con-2-puertas-atras.webp","canto":"fn-gabinete-de-bano-con-2-puertas-canto.webp","arriba":"fn-gabinete-de-bano-con-2-puertas-arriba.webp","w":200,"h":520,"wc":16,"ha":12},"brillo_foto":{"frente":171.0,"atras":183.0},"fondo":"fn-gabinete-de-bano-con-2-puertas-fondo.webp","abierta_izq":{"src":"fn-gabinete-de-bano-con-2-puertas-abierta-izq.webp","caja":[667,914,194,465]},"abierta_der":{"src":"fn-gabinete-de-bano-con-2-puertas-abierta-der.webp","caja":[1015,951,254,597]},"cam":{"P":[2091.278961,-64.68967,-2437.865121,250778.597836,-334.850291,-3222.452851,-310.404104,412066.608823,-0.670888,-0.06348,-0.738836,302.269091],"C":[170.521,86.376,246.855]},"puerta":{"W":18.35,"T":1.2,"XL":1.5,"XR":38.5,"YT":42.185,"YB":2.734,"izq":109.64,"der":83.33}}/*FIN*/;
  const S = E.lienzo({ w: 1600, h: 1600, vista: [515, 290, 1000, 1220], vistaMovil: [540, 230, 940, 1260] });
  E.titulo('Ábrelo y [guarda].', 'Toca cada puerta: gira sobre su bisagra y queda a la vista lo que guardas adentro.');
  E.conSonido();
  S.cargando(true);

  /* ---------- capas (todas de la foto real) ---------- */
  S.img(D.fondo, null, { z: 1, alt: 'Gabinete de baño blanco con repisas abiertas arriba y 2 puertas abajo' });
  const sombra = S.canvas([560, 1180, 760, 360], { z: 2, res: 0.5 });
  const TX = D.tex, PU = D.puerta, CAM = D.cam;
  function capa(src, w, h, z) { const i = S.img(src, [0, 0, w, h], { z }); i.style.transformOrigin = '0 0'; i.style.willChange = 'transform'; return i; }
  const P = {
    izq: { a: 0, meta: 0, max: PU.izq, frente: capa(TX.frente, TX.w, TX.h, 6), atras: capa(TX.atras, TX.w, TX.h, 6), canto: capa(TX.canto, TX.wc, TX.h, 7), arriba: capa(TX.arriba, TX.w, TX.ha, 7) },
    der: { a: 0, meta: 0, max: PU.der, frente: capa(TX.frente, TX.w, TX.h, 6), atras: null, canto: capa(TX.canto, TX.wc, TX.h, 7), arriba: capa(TX.arriba, TX.w, TX.ha, 7) }
  };
  ['izq', 'der'].forEach(l => {
    const R = D['abierta_' + l];
    P[l].real = S.img(R.src, R.caja, { z: 9, opacidad: 0 });
    P[l].real.style.transition = 'opacity .35s ease';
  });
  E.cargar([D.fondo, TX.frente, TX.atras, TX.canto, TX.arriba, D.abierta_izq.src, D.abierta_der.src]).then(() => { S.cargando(false); pintar('izq'); pintar('der'); });

  /* ---------- cámara real y geometría de cada puerta (cm) ---------- */
  const M = CAM.P, C = CAM.C, W = PU.W, T = PU.T;
  const proy = (x, y, z) => { const w = M[8] * x + M[9] * y + M[10] * z + M[11]; return [(M[0] * x + M[1] * y + M[2] * z + M[3]) / w, (M[4] * x + M[5] * y + M[6] * z + M[7]) / w]; };
  function pt(l, th, u, Y, s) {
    const t = th * Math.PI / 180, c = Math.cos(t), sn = Math.sin(t);
    return l === 'der' ? [PU.XR - u * c + s * sn, Y, u * sn + s * c] : [PU.XL + u * c - s * sn, Y, u * sn + s * c];
  }
  const q = (l, th, lista) => lista.map(a => { const p = pt(l, th, a[0], a[1], a[2]); return proy(p[0], p[1], p[2]); });
  const YT = PU.YT, YB = PU.YB;
  function caras(l, th) {
    return {
      frente: q(l, th, [[W, YT, 0], [0, YT, 0], [0, YB, 0], [W, YB, 0]]),
      atras: q(l, th, [[W, YT, -T], [0, YT, -T], [0, YB, -T], [W, YB, -T]]),
      canto: q(l, th, [[W, YT, -T], [W, YT, 0], [W, YB, 0], [W, YB, -T]]),
      arriba: q(l, th, [[W, YT, -T], [0, YT, -T], [0, YT, 0], [W, YT, 0]])
    };
  }
  function normales(l, th) {
    const t = th * Math.PI / 180, c = Math.cos(t), s = Math.sin(t);
    const fr = l === 'der' ? [s, 0, c] : [-s, 0, c], ca = l === 'der' ? [-c, 0, s] : [c, 0, s];
    return { frente: fr, atras: [-fr[0], 0, -fr[2]], canto: ca };
  }
  // luz de la foto (medida en las caras reales): más clara de frente y hacia la ventana (izquierda)
  const luz = n => 166 + 44 * n[2] + 15 * Math.max(0, -n[0]);
  const REF = { frente: luz([Math.sin(PU.der * Math.PI / 180), 0, Math.cos(PU.der * Math.PI / 180)]), atras: luz([Math.sin(PU.izq * Math.PI / 180), 0, -Math.cos(PU.izq * Math.PI / 180)]), canto: luz([-Math.cos(PU.der * Math.PI / 180), 0, Math.sin(PU.der * Math.PI / 180)]) };
  function visible(l, th, n, cara) {
    const t = th * Math.PI / 180, uc = W / 2;
    const p = cara === 'frente' ? pt(l, th, uc, (YT + YB) / 2, 0) : cara === 'atras' ? pt(l, th, uc, (YT + YB) / 2, -T) : pt(l, th, W, (YT + YB) / 2, -T / 2);
    return n[0] * (C[0] - p[0]) + n[2] * (C[2] - p[2]) > 0.01 && t >= 0;
  }
  function pintar(l) {
    const d = P[l], th = d.a, K = caras(l, th), N = normales(l, th);
    ['frente', 'atras', 'canto'].forEach(cara => {
      const e = d[cara]; if (!e) return;
      const v = visible(l, th, N[cara], cara) && !(l === 'der' && cara === 'atras');
      e.style.visibility = v ? 'visible' : 'hidden';
      if (!v) return;
      S.mapear(e, K[cara]);
      const b = luz(N[cara]) / REF[cara === 'atras' ? 'atras' : cara === 'canto' ? 'canto' : 'frente'];
      e.style.filter = 'brightness(' + b.toFixed(3) + ')';
    });
    // el frente de la izquierda es el de la derecha en espejo; la de atrás solo existe en la izquierda
    if (l === 'der' && d.atras) d.atras.style.visibility = 'hidden';
    S.mapear(d.arriba, K.arriba);
    d.arriba.style.visibility = th > 0.5 ? 'visible' : 'hidden';
    // al llegar a su ángulo real, la foto exacta
    const enFoto = Math.abs(th - d.max) < 0.4;
    d.real.style.opacity = enFoto ? 1 : 0;
    d.real.style.transition = enFoto ? 'opacity .35s ease' : 'none';
    sombras();
  }
  // sombra suave de cada puerta abierta en el piso: la luz entra por la ventana de la izquierda, así que la sombra
  // cae a la derecha de la puerta (en la foto real se ve bajo la puerta derecha abierta; aquí la acompaña al girar)
  const SOM = { izq: 0.08, der: 0.2 };
  function sombras() {
    sombra.limpiar();
    const c = sombra.ctx;
    ['izq', 'der'].forEach(l => {
      const th = P[l].a; if (th < 3) return;
      const k = Math.sin(Math.min(90, th) * Math.PI / 180);
      const a = pt(l, th, 0, 0, -T / 2), b = pt(l, th, W, 0, -T / 2);
      const pts = [proy(a[0], 0, a[2]), proy(b[0], 0, b[2]), proy(b[0] + 9, 0, b[2] + 2), proy(a[0] + 9, 0, a[2] + 2)];
      c.save(); c.filter = 'blur(' + Math.max(2, 16 * sombra.res).toFixed(1) + 'px)';
      c.fillStyle = 'rgba(52,44,36,' + (SOM[l] * k).toFixed(3) + ')';
      c.beginPath(); pts.forEach((p, i) => i ? c.lineTo(p[0], p[1]) : c.moveTo(p[0], p[1])); c.closePath(); c.fill(); c.restore();
    });
  }

  /* ---------- tocar las puertas ---------- */
  const ST = { abiertas: { izq: false, der: false }, vistas: { izq: false, der: false } };
  E.pasos(['Toca una puerta: se abre', 'Abre la otra y mira adentro', 'Ciérralas']);
  E.paso(0);
  const lect = E.lectura({ etiqueta: 'Alto · ancho · fondo' }); lect.poner('90 × 40 × 25', 'cm');
  const bIzq = E.boton('Puerta izquierda', () => tocar('izq'));
  const bDer = E.boton('Puerta derecha', () => tocar('der'));
  E.nota('Repisas abiertas de 24 y 16 cm de alto y gabinete de 40 cm con 2 puertas. Blanco.');

  const animando = { izq: null, der: null };
  function mover(l, meta, ms) {
    const d = P[l], a0 = d.a; d.meta = meta;
    if (animando[l]) animando[l]();
    return new Promise(r => {
      animando[l] = E.animar(ms, k => { d.a = a0 + (meta - a0) * k; pintar(l); }, () => { animando[l] = null; d.a = meta; pintar(l); r(); }, meta > a0 ? E.salida : E.suave);
    });
  }
  async function tocar(l) {
    const abrir = !ST.abiertas[l];
    ST.abiertas[l] = abrir;
    (l === 'izq' ? bIzq : bDer).texto((abrir ? 'Cierra la ' : 'Abre la ') + (l === 'izq' ? 'izquierda' : 'derecha'));
    E.sonido.clic(); E.vibrar(8);
    if (abrir) ST.vistas[l] = true;
    const ms = abrir ? 1150 : 900;
    await mover(l, abrir ? P[l].max : 0, ms);
    if (!abrir) { E.sonido.tono(170, 0.08, 0.06); E.vibrar(12); }
    guia();
  }
  function guia() {
    const n = (ST.abiertas.izq ? 1 : 0) + (ST.abiertas.der ? 1 : 0);
    zonas();
    if (n === 2) { E.paso(2); S.pista('Ahora ciérralas: toca cada puerta', 'toca'); return; }
    if (n === 1) {
      if (ST.vistas.izq && ST.vistas.der) { E.paso(2); S.pista('Toca la otra puerta para cerrarla', 'toca'); return; }
      E.paso(1); S.pista('Abre la otra puerta', 'toca'); return;
    }
    if (ST.vistas.izq && ST.vistas.der) {
      E.paso(3); S.pista(null);
      E.listo('Arriba, repisas abiertas de 24 y 16 cm para lo de todos los días; abajo, el gabinete de 40 cm con 2 puertas para el papel y los productos de aseo.', reiniciar);
      return;
    }
    E.paso(0); S.pista('Toca una puerta', 'toca');
  }

  // zonas tocables: cada puerta donde está ahora (cerrada o abierta)
  const zI = S.toque([0, 0, 10, 10], { etiqueta: 'Puerta izquierda: tócala para abrirla o cerrarla', alTocar: () => tocar('izq'), z: 50 });
  const zD = S.toque([0, 0, 10, 10], { etiqueta: 'Puerta derecha: tócala para abrirla o cerrarla', alTocar: () => tocar('der'), z: 50 });
  function caja(l, th) {
    const K = caras(l, th), pts = K.frente.concat(K.atras);
    const xs = pts.map(p => p[0]), ys = pts.map(p => p[1]);
    return [Math.min(...xs), Math.min(...ys), Math.max(...xs) - Math.min(...xs), Math.max(...ys) - Math.min(...ys)];
  }
  // anillo que invita, en el pomo real de cada puerta (también se puede tocar)
  const POMO = { u: 15.0, Y: 21.5 };
  const rI = S.toque([0, 0, 10, 10], { redonda: true, etiqueta: 'Pomo de la puerta izquierda', alTocar: () => tocar('izq'), z: 52 });
  const rD = S.toque([0, 0, 10, 10], { redonda: true, etiqueta: 'Pomo de la puerta derecha', alTocar: () => tocar('der'), z: 52 });
  function zonas() {
    [['izq', rI], ['der', rD]].forEach(([l, r]) => {
      const p = pt(l, ST.abiertas[l] ? P[l].max : 0, POMO.u, POMO.Y, 0.8), q2 = proy(p[0], p[1], p[2]);
      const d = Math.max(64, 50 / Math.max(S.k, 0.05));
      r.style.left = (q2[0] - d / 2) + 'px'; r.style.top = (q2[1] - d / 2) + 'px'; r.style.width = d + 'px'; r.style.height = d + 'px';
    });
    [['izq', zI], ['der', zD]].forEach(([l, z]) => {
      const b = caja(l, ST.abiertas[l] ? P[l].max : 0);
      // mínimo 44 px en pantalla: la zona crece, la puerta no
      const minW = 44 / Math.max(S.k, 0.05);
      const w = Math.max(b[2], minW), x = b[0] - (w - b[2]) / 2;
      z.style.left = x + 'px'; z.style.top = b[1] + 'px'; z.style.width = w + 'px'; z.style.height = b[3] + 'px';
    });
    const ambas = ST.vistas.izq && ST.vistas.der;
    rI.classList.toggle('is-pista', !ST.vistas.izq || (ambas && ST.abiertas.izq));
    rD.classList.toggle('is-pista', !ST.vistas.der || (ambas && ST.abiertas.der));
  }

  function reiniciar() {
    E.noListo();
    ST.vistas = { izq: false, der: false };
    Promise.all(['izq', 'der'].map(l => { ST.abiertas[l] = false; return mover(l, 0, 700); })).then(() => {
      bIzq.texto('Puerta izquierda'); bDer.texto('Puerta derecha'); guia();
    });
  }

  pintar('izq'); pintar('der'); zonas(); requestAnimationFrame(zonas);
  S.pista('Toca una puerta', 'toca');
  window.addEventListener('resize', zonas);
});
